<bst-svg></bst-svg>
<a class="skip-link" href="#main-content" (click)="skipToContent($event)">{{ 'shell.skip_to_content' | translate }}</a>
<nb-layout>

  <nb-layout-header fixed>
    <bst-header class="content-center header"></bst-header>
  </nb-layout-header>

  @if (user) {
    <nb-sidebar
        responsive
        [fixed]="isMobile"
        tag="menu"
        class="rail-sidebar"
        role="navigation"
        [attr.aria-label]="'shell.main_navigation' | translate"
        [attr.inert]="isMobile && !sidebarOpen ? '' : null"
        [attr.aria-hidden]="isMobile && !sidebarOpen ? 'true' : null"
        [collapsedBreakpoints]="['xs','is','sm']"
        [compactedBreakpoints]="[]">
      <bst-sidebar></bst-sidebar>
    </nb-sidebar>
  }

  <nb-layout-column id="main-content" role="main" tabindex="-1">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </nb-layout-column>

</nb-layout>
<!-- backdrop lives OUTSIDE nb-layout: a sibling inside the sidebar's @if breaks
     nb-layout content projection (NG8011). It's position:fixed so placement is moot. -->
@if (user && isMobile && sidebarOpen) {
  <div class="sidebar-backdrop" (click)="closeSidebar()"></div>
}
